import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Children } from 'react';
import Default from 'react-bootstrap/Button';
import { useTemplateLoader } from '../../template-loader/template-loader.esm.js';

const ButtonBase = ({ children, className, withStroke, size, variant = 'primary', fluid = false, onClick, templateId, ...rest })=>{
    const numberOfChildren = Children.toArray(children).length;
    const { setSelectedTemplate } = useTemplateLoader();
    const sizeValue = size === 'md' ? undefined : size;
    return jsx(Default, {
        className: classNames(className, {
            [`btn-${variant}-stroke`]: withStroke,
            'btn-fluid': fluid
        }),
        size: sizeValue,
        variant: variant,
        onClick: (event)=>{
            if (templateId) {
                /**
                 * If `templateId` is specified, we will override the default behaviour
                 * of the click handler in order to trigger the account picker
                 *
                 * TODO: Move this to the Cta module
                 */ event.preventDefault();
                setSelectedTemplate({
                    metadataId: templateId
                });
                return;
            }
            onClick?.(event);
        },
        ...rest,
        children: jsx("div", {
            className: classNames({
                'd-flex align-items-center gap-50 text-capitalize': numberOfChildren > 1
            }),
            children: children
        })
    });
};

export { ButtonBase };
